import { fetchListHotel, bookHotel, fetchServices, getMatrixHotels, executeBookingByLambda } from '@/api/service'

const updateListHotel = (context, payload) => {
  fetchListHotel(payload).then((response) => {
    if (response?.reservation && response.reservation.length > 0) {
      _.each(response.reservation, function (res) {
        if (!res.total_estimate_cost) {
          res.total_estimate_cost = 0
        }
      })
      context.commit('DATA_LIST_HOTEL_UPDATED', response.reservation)
    } else if (response?.list_hotel && response.list_hotel.length > 0) {
      _.each(response.list_hotel, function (res) {
        if (!res.total_estimate_cost) {
          res.total_estimate_cost = 0
        }
      })
      context.commit('DATA_LIST_HOTEL_UPDATED', response.list_hotel)
      context.commit('IS_INVENTORY_LIST', 1)
    } else {
      context.commit('DATA_LIST_HOTEL_UPDATED', [])
    }
  })
}

const fetchMatrixHotels = (context, payload) => {
  return getMatrixHotels(payload).then((response) => {
    return response
  })
}

const bookListHotel = async (context, payload) => {
  if (process.env.VUE_APP_SENTRY_ENVIRONMENT === 'local') {
    return bookHotel(payload).then((response) => {
      return response
    })
  } else {
    return await executeBookingByLambda(payload)
  }
}

const getServices = (context) => {
  return fetchServices().then((response) => {
    context.commit('SERVICES_UPDATED', _.keyBy(response, 'service_id'))
    return context.state.services
  })
}

export default {
  updateListHotel,
  bookListHotel,
  getServices,
  fetchMatrixHotels
}
